import * as types from "./obrasParticulares.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  Situacao: undefined,
  Tipo: undefined,
  parametro: undefined,
  registrarSolicitacao: {
    parametro: [],
  }
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    default:
      return state;
  }
};

store.registerDynamicModule("obrasParticulares", reduce);
